import { colors } from "UI/colors";

import { colorIsLight } from "Utilities/Colors/colorUtils";

/*
Fund colors come in from the backend as 6 digit color codes (i.e. "2A6984")
Returns the passed in value (with a "#" added to the front), unless its "too light" (not enough contrast),
in which case it returns our fnBlue color as a fallback.
*/

export function getSafeFundColor(colorCode) {
  // remove the leading "#" from colorCode (if present)
  if (colorCode?.startsWith("#")) {
    colorCode = colorCode.slice(1);
  }

  const isLight = colorIsLight(colorCode);

  if (isLight) {
    return colors.fnBlue;
  } else {
    return "#" + colorCode;
  }
}
